export default "__VITE_ASSET__De$p9Jju__"